<template>
    <div class="customer-open-customer-btn">
        <v-tooltip bottom v-if="alternativeBtn">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    class="drei_60-btn mb-2"
                    block
                    @click="showDetails(ssoId)"
                    :disabled="disabled"
                >
                    Kundendetails aufrufen
                </v-btn>
            </template>
            <div class="max-width-btn">
                Kundendetails aufrufen
            </div>
        </v-tooltip>
        <v-tooltip left v-if="!alternativeBtn">
            <template #activator="{ on }">
                <v-btn
                    v-on="on"
                    text
                    icon
                    class="drei_60-black-text"
                    @click="showDetails(ssoId)"
                    :disabled="disabled"
                >
                    <v-icon v-bind="$attrs">mdi-account-circle</v-icon>
                </v-btn>
            </template>
            <span>Kundendetails aufrufen</span>
        </v-tooltip>
    </div>
</template>
<script>
import Route from '@/route';

export default {
    name: 'OpenCustomerBtn',
    props: ['ssoId', 'alternativeBtn', 'disabled'],
    methods: {
        showDetails(ssoId) {
            this.$router.push({
                name: Route.CUSTOMER_C1.name,
                params: {
                    sso_id: ssoId,
                },
            });
        },
    },

};

</script>
<style scoped lang="scss"></style>
